import React from 'react';
import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../config/firebaseConfig';
import { Container, Button, Row, Col, Modal, Image, Badge, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import actions from '../../image/actions.png';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';


export default function Home() {
  const { currentUser } = useAuth();
  const [userData, setUserData] = useState(null);
  const [showExplication, setShowExplication] = useState(false);
  const [showExemple, setShowExemple] = useState(false);

  const navigate = useNavigate();

  const handleCloseExplication = () => {
    setShowExplication(false);
  };

  useEffect(() => {
    if (!currentUser) return;

    const unsubscribe = db.collection('users').doc(currentUser.uid).onSnapshot(
      (doc) => {
        if (doc.exists) {
          setUserData(doc.data());
        }
      },
      (error) => {
        console.error("Erreur de chargement Firestore :", error);
      }
    );
    return unsubscribe;
  }, [currentUser]);

  const firstName = userData?.firstName || "";


  return (
    <Container className="home-page">
      <XyzTransition appear xyz='fade duration-20 appear delay-4'>
        <div className="bg-dark py-4 text-center border-bottom mt-5">
          <Container className="shadow-sm py-2">
            <Row className="justify-content-center">
              <Col md={8}>
                <h1 className="display-5 fw-semibold text-light mb-4">Bienvenue <span className="highlight">{firstName}</span> sur Memento</h1>
                <div className="para-memento">
                  <p className="text-warning mb-4">
                    La procrastination est la tendance à remettre systématiquement au lendemain ou à plus tard l'exécution d'une tâche ou d'une décision.
                    C'est l'ennemie de l'action, Memento en est l'antidote.
                  </p>
                  {!currentUser && (
                    <p className="text-danger mb-2">
                      Avant de commencer, vous allez vous inscrire sur Memento afin de profiter de l'application.<br />
                      Ensuite, vous cliquerez sur les boutons "Sommaire" et "Aperçu" dans la barre de navigation située en haut.<br />
                      Cela vous donnera une explication et une idée du rendu final.<br />
                      Vous n'avez plus qu'à remplir les champs du formulaire et cliquer ensuite sur le bouton "Ajouter".<br /><br />
                      Voici ce que donnera le rendu visuel de vos actions en cours en cliquant sur le bouton "Aperçu".<br />
                    </p>
                  )}

                  {!currentUser && (
                    <React.Fragment>
                      <p className='d-flex justify-content-center mt-3 mb-2'>
                        <Button className='fw-semibold' variant="outline-warning" onClick={() => setShowExemple(true)}>
                          Aperçu
                        </Button>
                      </p>
                      <p className="text-danger mb-1">Vous venez de créer votre première action à réaliser.</p>
                      <p className="text-danger pt-1 mb-0">Bravo !</p>
                    </React.Fragment>
                  )}

                  {currentUser && (
                    <React.Fragment>
                      <p className="text-light mb-2">
                        Retrouvez toutes vos actions en cliquant sur le bouton "Actions" juste en dessous:
                    </p>
                      <div className='d-flex justify-content-center align-items-center mt-4 mb-1'>
                        <div className='nav-link divModal px-3' onClick={() => { setShowExplication(true); setShowExemple(false) }}>
                          <Button className='fw-semibold' variant="outline-warning">
                            Sommaire
                          </Button>
                        </div>
                        <div className='nav-link divModal' onClick={() => { setShowExemple(true); setShowExplication(false) }}>
                          <Button className='fw-semibold' variant="outline-warning">
                            Aperçu
                          </Button>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </XyzTransition>


      {/* 1. MODALE EXPLICATION (SOMMAIRE) */}
      <Modal
        show={showExplication}
        onHide={handleCloseExplication}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
        contentClassName="bg-dark text-white shadow-lg border-secondary"
        className="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down"
      >
        <Modal.Header closeButton closeVariant="white" className="border-secondary">
          <Modal.Title className="fs-3 fw-semibold w-100 text-center text-info">
            ✨ Explication du Memento
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 py-4">
          <section className="mb-4">
            <h5 className="text-center text-info fw-semibold mb-2">👋 Bienvenue sur le Memento</h5>
            <p className="text-light-50 lh-base fs-5">
              Rien de bien compliqué ! Il vous faudra en premier lieu{' '}
              <strong className="text-white">créer votre espace personnel</strong> en y ajoutant votre adresse mail ainsi qu'un mot de passe.
              Ensuite, vous ajouterez tous vos projets du moment et profiterez d'une{' '}
              <strong className="text-white">meilleure gestion de votre agenda personnel</strong>.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="text-center text-info fw-semibold mb-3">📊 Schéma explicatif</h5>
            <Card className="bg-secondary text-white border-0 p-3 mb-3 shadow-sm">
              <div className="d-flex align-items-center gap-2 mb-2">
                <Badge bg="info" className="text-dark">Exemple</Badge>
                <span className="fw-medium">Personnalisation des tâches</span>
              </div>
              <p className="mb-0 text-light-50 fs-6">
                Vous aurez la possibilité de changer la couleur du fond de l'action en cliquant sur le{' '}
                <strong className="text-info">color picker</strong> en sélectionnant l'icône situé en bas de l'action.
              </p>
            </Card>
          </section>

          <section className="mb-4">
            <h5 className="text-center text-info fw-semibold mb-2">🎁 Les Bonus</h5>
            <ul className="list-unstyled ps-2 fs-6">
              <li className="mb-2 d-flex align-items-start gap-2">
                <span role="img" aria-label="Note de musique">🎵</span>
                <span>Un <strong>lecteur média</strong> situé en haut à gauche de votre écran de réglage vous attend, et un morceau de musique zen vous accompagnera...</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <span role="img" aria-label="Lune premier quartier">🌓</span>
                <span>Vous aurez également la possibilité de changer le thème principal de Memento en <strong>mode foncé ou clair</strong>.</span>
              </li>
            </ul>
          </section>

          <div className="text-center mt-5 pt-3 border-top border-secondary">
            <h4 className="fw-semibold text-success animate-pulse">🚀 Bonne organisation !</h4>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-secondary justify-content-center">
          <Button
            variant="info"
            size="lg"
            className="px-5 text-dark fw-semibold"
            onClick={() => {
              setShowExplication(false);
              setShowExemple(false);
              // Si connecté on l'envoie aux actions, sinon à l'accueil
              if (currentUser) navigate('/actions');
            }}
          >
            C'est parti !
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 1. MODALE EXEMPLE (APERÇU) */}
      <Modal
        show={showExemple}
        onHide={() => setShowExemple(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
        contentClassName="bg-dark text-white shadow-lg border-secondary"
        className="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down"
      >
        <Modal.Header closeButton closeVariant="white" className="border-secondary">
          <Modal.Title className="fs-3 fw-semibold w-100 text-center text-info">
            ✨ Exemple & Aperçu
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 py-4">
          <section className="mb-4">
            <h5 className="text-info fw-semibold mb-3">📸 Capture d'écran du Memento</h5>

            <Card className="bg-secondary text-white border-0 overflow-hidden mb-3 p-2 shadow">
              <div className="p-2 border-bottom border-dark d-flex align-items-center gap-2 mb-2">
                <Badge bg="info" className="text-dark">Un aperçu</Badge>
                <small className="fw-medium text-light-50">Interface de vos actions</small>
              </div>
              <Image
                src={actions}
                className="img-fluid w-100 object-fit-cover"
                alt="Aperçu des actions Memento"
              />
            </Card>

            <p className="text-light-50 lh-base fs-5 text-center mt-3">
              Voici l'aperçu des actions s'affichant sur votre écran.
            </p>
          </section>

          <div className="text-center mt-5 pt-3 border-top border-secondary">
            <h4 className="fw-semibold text-success">🚀 Bonne découverte !</h4>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-secondary justify-content-center">
          {currentUser ? (
            // 🟢 SI L'UTILISATEUR EST CONNECTÉ : Redirection directe vers son tableau de bord
            <Button
              variant="info"
              size="lg"
              className="px-5 text-dark fw-semibold"
              onClick={() => {
                setShowExemple(false); // 🎯 Sécurité : on ferme la modale avant de partir
                navigate('/actions');
              }}
            >
              Voir mes actions
            </Button>
          ) : (
              // 🔴 SI L'UTILISATEUR N'EST PAS CONNECTÉ : Redirection vers l'authentification
              <Button
                variant="info"
                size="lg"
                className="px-5 text-dark fw-semibold"
                onClick={() => {
                  setShowExemple(false); // 🎯 Sécurité : on ferme la modale avant de partir
                  navigate('/connexion');
                }}
              >
                Connexion
              </Button>
            )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
}